import { render, staticRenderFns } from "./restock-repair-issues.vue?vue&type=template&id=24ab0d9c&"
import script from "./js/restock-repair-issues.js?vue&type=script&lang=js&"
export * from "./js/restock-repair-issues.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports